export default "__VITE_ASSET__DIOPcOPN__"